import React from 'react';

import CardHOC from './Components/CardHOC';
import Choice from '../../Types/Components/Choice';

export default function (props) {
  return <CardHOC question={props.question}>
    <Choice {...props} />
  </CardHOC>;
}